<template>
  <div id="sign-in" class="row">
      <div class="col-md-8 ml-auto mr-auto">
        <card type="user">
          <div class="card-header">
            <h5 class="title welcome-text">Welcome to the Login of your elegant account</h5>
          </div>
          <div class="card-body">
            <div class="author">
              <div class="block block-one"></div>
              <div class="block block-two"></div>
              <div class="block block-three"></div>
              <div class="block block-four"></div>
              <a href="#">
                <img class="avatar" src="img/default.png" alt="...">
              </a>
            </div>
            <p></p>
            <form @submit.prevent>
              <div class="row">
                <div class="col-md-12">
                  <base-input label="Email address"
                              type="email"
                              placeholder="Enter email"
                              v-model="login.email"
                              v-bind:error="errors.email"
                              v-bind:class="{ 'has-danger': !validation.email }">
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <base-input label="Password"
                              type="password"
                              placeholder="Enter password"
                              v-model="login.pwd"
                              v-bind:error="errors.pwd"
                              v-bind:class="{ 'has-danger': !validation.pwd }">
                  </base-input>
                </div>
              </div>
              <p>
                <br><br><br>
              </p>
              <div class="row">
                <div class="col-md-12 ml-auto mr-auto">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <button type="button" class="btn btn-primary btn-block" v-on:click="authentication()">Sign In</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p><br></p>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <button type="button" class="btn btn-danger btn-block" v-on:click="newPassword()">Forgot password</button>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <button type="button" class="btn btn-default btn-block" v-on:click="addUserForm()">Sign Up</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </card>
      </div>
    </div>
</template>

<script>
  import {url} from "../../plugins/axios";
  import { setCookie} from "../../plugins/axios";
  import axios from 'axios';

  export default {
    props: ['activity'],
    name: "sign-in",
    data() {
      return {
        login: {"email":"","pwd":""},
        validation:{'email':true,'pwd':true},
        errors:{email:'', pwd:''},
      }
    },
    methods:{
      authentication() {
        this.validation.email = (this.login.email !== '');
        this.validation.pwd = (this.login.pwd !== '');
        this.errors.email = (!this.validation.email) ? 'Email could not be empty' : '';
        this.errors.pwd = (!this.validation.pwd) ? 'Password could not be empty' : '';

        if(this.validation.pwd&&this.validation.email){
          this.$emit('show-loading', true);
          this.logout().then(res =>{
            axios
            .post(url + 'authenticate/',
              {
                data: {"user_name":this.login.email, "pwd":this.login.pwd}
              },
              {
                withCredentials:'include',
                crossDomain:true
              })
              .then((response) => {
                if (response.data.result.status === 'You have authenticated'){
                  setCookie('Authentication','',-1);
                  setCookie('Authentication','Pass',1);
                  setCookie('Project-id', response.data.result.employee['projectId']);
                  setCookie('Employee-id',response.data.result.employee['id']);
                  setCookie('User-id',response.data.result.user['id']);
                  setCookie('Type-id',response.data.result.user['typeId']);
                  this.$router.push('/').catch(err => {console.log(err)});
                }
                else{
                  setCookie('Authentication','Failed',1);
                  this.errors.email = response.data.error;
                  this.errors.pwd = response.data.error;
                }
                this.$emit('show-loading', false)
              })
              .catch((error) => {
              });
          });
        }
      },
      addUserForm: function () {
        this.activity.signIn = false;
        this.activity.signUp = true;
      },
      newPassword: function () {
        this.activity.signIn = false;
        this.activity.changePsw = true;
      },
      async logout() {
        setCookie('Authentication','',-1);
        setCookie('Project-id', '', -1);
        setCookie('Employee-id', '', -1);
        setCookie('User-id', '', -1);
        setCookie('Type-id', '', -1);
        await axios
          .get(url + 'logout/',
            {
              withCredentials:'include',
              crossDomain:true
            })
        ;
      },
    },
    mounted() {}
  }
</script>

<style scoped>
  .welcome-text{
    font-size: 16px;
  }
  .has-danger:after{
    top:45px;
  }
</style>
